$mol_view_tree2_to_js_test_ex_simple_string_foo $mol_object
	hardcoded \
		\First
		\Second
	localized @ \bla
